import React, { useEffect, useState } from "react";
import "./UserDashboard.scss";
// import { LuFileEdit } from "react-icons/lu";
import { RedMainHeading, SubHeading } from "../../Global/GlobalText";
import { HiMiniCurrencyDollar } from "react-icons/hi2";
import { RedBackgroundButton } from "../../Global/GlobalButton";
import { UserTitlebar } from "../../Global/User-Flow/UserTitleBar/UserTitleBar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { USER_EXCHNAGE_URL } from "../../../Url/Url";

export const UserDashboard = () => {
  const [eventCount, setEventCount] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token")
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${USER_EXCHNAGE_URL}/usersubmssioncount`, {
          headers: {
            Authorization: `Bearer ${token}`,

          }
        });
        if (response.status === 200) {
          const data = response?.data?.data?.total_events
          setEventCount(data)
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);



  return (
    <>
      <div className="user_dashboard_div">
        <UserTitlebar title="User Dashboard" />
        <div className="user_dashboard_bg">
          <div className="user_price_div">
            <div className="user_dashboard_sub sub_details " onClick={() => navigate("/submission")}
            >
              {/* <LuFileEdit/> */}
              <RedMainHeading>SUBMISSION DETAILS </RedMainHeading>
              <SubHeading style={{ fontWeight: 600 }}> {eventCount} </SubHeading>
            </div>
            <div className="user_dashboard_sub pending_pay" onClick={() => {
              navigate(`/user-submission-dashbaord`);
            }}>
              <HiMiniCurrencyDollar />
              <RedMainHeading>Payment's</RedMainHeading>
      <RedBackgroundButton
    // onClick={handlePayment}
    style={{
      // marginLeft: "auto",
      // padding: "8px 16px",
    }}
  >
    Tap to Pay
  </RedBackgroundButton>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
